export * from './BoxIcon'
export * from './CircleIcon'
export * from './DashDashedIcon'
export * from './DashDottedIcon'
export * from './DashDrawIcon'
export * from './DashSolidIcon'
export * from './IsFilledIcon'
export * from './RedoIcon'
export * from './TrashIcon'
export * from './UndoIcon'
export * from './SizeSmallIcon'
export * from './SizeMediumIcon'
export * from './SizeLargeIcon'
export * from './EraserIcon'
export * from './MultiplayerIcon'
export * from './LineIcon'


// WEBPACK FOOTER //
// ./src/modules/whiteboard/components/icons/index.ts